import { formatAccountName } from "./formatters";

export const getDestinationIdentifierLabel = (
  householdData,
  destinationType,
  destinationIdentifier,
) => {
  if (
    !householdData ||
    destinationIdentifier == null ||
    destinationIdentifier === ""
  )
    return destinationIdentifier ?? "N/A";
  if (destinationType === "Brokerage Account") {
    const accIndex = (householdData.accounts || []).findIndex(
      (a) => a.id === destinationIdentifier,
    );
    if (accIndex === -1) return String(destinationIdentifier);
    const acc = householdData.accounts[accIndex];
    return formatAccountName(acc, accIndex + 1, householdData.members || []);
  }
  if (destinationType === "Bank Account") {
    const ba = (householdData.bank_accounts || []).find(
      (b) => b.id === destinationIdentifier,
    );
    return ba
      ? `${ba.bank_name || "Bank"} - ${ba.account_number || "N/A"}`
      : String(destinationIdentifier);
  }
  return destinationIdentifier ?? "N/A";
};

export const getDestinationIdentifierOptions = (
  householdData,
  destinationType,
  currentAccountId = null,
) => {
  if (!householdData) return [];
  if (destinationType === "Brokerage Account") {
    return (householdData.accounts || [])
      .filter((acc) => acc.id !== currentAccountId)
      .map((acc) => {
        const actualIndex = householdData.accounts.findIndex(
          (a) => a.id === acc.id,
        );
        return {
          value: acc.id,
          label: formatAccountName(
            acc,
            actualIndex + 1,
            householdData.members || [],
          ),
        };
      });
  }
  if (destinationType === "Bank Account") {
    return (householdData.bank_accounts || []).map((ba) => ({
      value: ba.id,
      label: `${ba.bank_name || "Bank"} - ${ba.account_number || "N/A"}`,
    }));
  }
  return [];
};
